import { useContext } from 'react';

import { BrandContext } from '~/modules/branding';

export const useBrand = () => useContext(BrandContext);
